const queryLang = new URLSearchParams(document.location.search).get('lang')
const lang = queryLang && ['en', 'ru'].includes(queryLang) ? queryLang : ''

export const language = (process.env.REACT_APP_LANG || lang || 'en') as
  | 'en'
  | 'ru' /*CHOOSE LANGUAGE*/

export const config = {
  language,
  links: {
    en: process.env.REACT_APP_LINK_EN,
    ru: process.env.REACT_APP_LINK_RU,
  },
}
